// extracted by mini-css-extract-plugin
module.exports = {"for-guides__wrapper":"ForGuidesContainer_for-guides__wrapper__1yOIy"};